import { getUtmParams } from "./utm";

const CALENDLY_BASE_URL =
  process.env.REACT_APP_CALENDLY_URL ||
  "https://calendly.com/talkpal-for-business/demo-with-nikoloz";

export const CALENDLY_CONSULTATION_URL = CALENDLY_BASE_URL;

export const setCalendlyPrefill = (prefill: {
  firstName?: string;
  lastName?: string;
  email?: string;
}) => {
  const name = [prefill.firstName, prefill.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  if (name) window.localStorage.setItem("calendlyPrefillName", name);
  if (prefill.email)
    window.localStorage.setItem("calendlyPrefillEmail", prefill.email);
};

export const getCalendlyPrefill = () => ({
  name: window.localStorage.getItem("calendlyPrefillName") || "",
  email: window.localStorage.getItem("calendlyPrefillEmail") || "",
});

export const buildCalendlyConsultationUrl = () => {
  const { name, email } = getCalendlyPrefill();
  const url = new URL(CALENDLY_CONSULTATION_URL);

  if (name) url.searchParams.set("name", name);
  if (email) url.searchParams.set("email", email);

  Object.entries(getUtmParams()).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value);
  });

  return url.toString();
};

export const openCalendlyConsultation = () => {
  window.open(buildCalendlyConsultationUrl(), "_blank", "noopener,noreferrer");
};
